import { render, staticRenderFns } from "./EditAppItem.vue?vue&type=template&id=2be6905d&scoped=true&lang=pug&"
import script from "./EditAppItem.vue?vue&type=script&lang=js&"
export * from "./EditAppItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6905d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
